import { render, staticRenderFns } from "./MapDetails.vue?vue&type=template&id=674ba57e&"
import script from "./MapDetails.vue?vue&type=script&lang=js&"
export * from "./MapDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports